<template>
  <qb-sidebar
    :name="name"
    :title="title | upperCase"
    :bgColor="color"
    textColor="#fff"
    size="lg"
    :loading="loading"
    @open="open"
  >
    <template v-slot:header>
      <vs-row vs-justify="center" class="px-4 mb-4 f-14">
        <vs-col vs-type="flex" vs-w="12" class="mt-2">
          <p>
            <strong>{{ $t('publish_date') | capitalize }} :</strong>
             {{ formatDate(data.created_at) }}
      
          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p>
            <strong>{{ $t('start_date') | capitalize }} :</strong>
             {{ formatDate(data.start_date) }}
  
          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p>
            <strong>{{ $t('required') | capitalize }} :</strong>
             {{ data.vacancies}}

          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p v-if="data.shift">
            <strong>{{ $t('shift') | capitalize }} :</strong>
             {{ data.shift.name}}

          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p>
            <strong>{{ $t('aging') | capitalize }} :</strong>
             {{ data.aging  | capitalize}}

          </p>
        </vs-col> 
      </vs-row>
      <vs-row  vs-justify="flex-end" class="p-4 mb-4">
        <vs-col  vs-type="flex" vs-xs="12" vs-sm="4" vs-lg="4">
          <qb-status-card
            v-if="data.position_status"
            :textColor="data.position_status.color"
            :text="data.position_status.name"
          />
        </vs-col>
      </vs-row>
    </template>
    <vs-row vs-justify="flex-center" class="px-4 mb-4"> </vs-row>
    <vs-row vs-justify="flex-center" class="px-4 mb-4">
      <vs-col vs-type="flex" vs-w="12" >
          <p>
            <strong>{{ $t('description') | capitalize }} :</strong><br>
             {{ data.description}}

          </p>
      </vs-col>
      <vs-col vs-type="flex" vs-w="12" class="mt-3">
          <p>
            <strong>{{ $t('company_profile') | capitalize }} :</strong><br>
             {{ data.requirements}}

          </p>
      </vs-col>
      </vs-row>
      <vs-row vs-justify="flex-center" class="px-4 mb-4">
      <vs-col>
        <vs-table srtiped :key="data.id" :data="dataTable"
          >
          <template slot="thead">
            <vs-th>
              {{$t('candidate')}}
            </vs-th>
            <vs-th>
              {{$t('job_title') | capitalize }}
            </vs-th>
            <vs-th>
              Visa / Sentri
            </vs-th>
            <vs-th>
              {{$t('language')+'(s)'}}
            </vs-th>
            <vs-th>
              {{$t('experience')}}
            </vs-th>
            <vs-th>
              {{$t('salary')}}
            </vs-th>
            <vs-th>
              {{$t('status')}}
            </vs-th>
          </template>

          <template >
            <vs-tr class="content-table" style="color: blue" >
              <vs-td >
                Reference
              </vs-td>

              <vs-td v-if="data.position_title">
                {{data.position_title.name}}
              </vs-td>

              <vs-td >
                {{this.visa !== false ? $t('yes'): 'NO' | upperCase }} / {{this.sentri !== false ? $t('yes'): 'NO' | upperCase}}
              </vs-td>

              <vs-td v-if="data.languages && data.languages.length > 0" >
                <span :key="indextr" v-for="(language, indextr) in data.languages">{{language.name + ' ' + language.pivot.percentage + '%'}}</span>
              </vs-td>
              <vs-td v-else>
                <span > {{ $t('none') | capitalize }}</span>
              </vs-td>

              <vs-td >
                {{data.experience_years}} {{$t('year')+'s' | capitalize }}
              </vs-td>

              <vs-td >
                {{data.salary_min + ' - ' + data.salary_max}}
              </vs-td>

              <vs-td >
               
              </vs-td>

              <template class="expand-position" slot="expand">
                    <vs-col class="content-table" vs-offset="0.3" vs-w="12" >
                        <vs-row class="mb-5">
                            <vs-col  vs-type="flex" vs-w="2" >
                                <b style="color: #76838f; !important">{{$t('education') | capitalize }}:</b>
                            </vs-col>
                            <vs-col  vs-type="flex" vs-w="4" >
                                <span v-if="data.academic"> {{data.academic.name}}</span>
                            </vs-col>
                            <vs-col vs-type="flex" vs-w="2" >
                                <b style="color: #76838f; !important">{{$t('city') | capitalize }}:</b>
                            </vs-col>
                            <vs-col  vs-type="flex" vs-w="4" >
                                <span v-if="data.city"> {{data.city.name}}</span>
                            </vs-col>
                        </vs-row>
                        <hr style="height:1px;border:none;color:#e4eaec;background-color:#e4eaec;">
                        <vs-row class="mb-5 mt-1">
                          <vs-col  vs-type="flex" vs-w="2" >
                            <b style="color: #76838f; !important">{{$t('certifications')}}:</b>
                          </vs-col>
                          <vs-col  vs-type="flex" vs-w="4" >
                            <p v-if="data.certifications"><span :key="indextr" v-for="(certification, indextr) in data.certifications"> {{certification.name}}</span></p>
                          </vs-col>
                          <vs-col  vs-type="flex" vs-w="2">
                            <b style="color: #76838f; !important">{{$t('skills')}}:</b>
                          </vs-col>
                          <vs-col  vs-type="flex" vs-w="4" >
                              <p v-if="data.skills"><span :key="indextr" v-for="(skill, indextr) in data.skills"> {{skill.name}}</span></p>
                          </vs-col>
                        </vs-row>
                        <hr style="height:1px;border:none;color:#e4eaec;background-color:#e4eaec;">
                        <vs-row>
                            <vs-col  vs-type="flex" vs-w="2">
                            <b style="color: #76838f; !important">{{$t('major')}}:</b>
                            </vs-col>
                            <vs-col  vs-type="flex" vs-w="4" v-if="data.majors">
                              <span :key="indextr" v-for="(major, indextr) in data.majors"> {{major.name}}</span>
                            </vs-col>
                        </vs-row>
                        
                    </vs-col>
            
              </template>
            </vs-tr>
            <vs-tr class="content-table"  :key="indextr" v-for="(application, indextr) in data.applications" >
              <vs-td >
                {{application.name + ' ' + application.lastname}}
              </vs-td>

              <vs-td v-if="data.position_title">
                {{application.Major}}
              </vs-td>

              <vs-td >
                {{application.visa === '1' ? $t('yes'):'NO' | upperCase }}/{{application.sentri === '1' ? $t('yes'):'NO' | upperCase }}
              </vs-td>

              <vs-td  >
                <span v-if="application.English">{{application.English}} %</span>
                <span v-else>0 %</span>
              </vs-td>

              <vs-td >
                {{application.experience_years}} {{$t('year')+'s' | capitalize }}
              </vs-td>

              <vs-td >
                {{application.current_salary + ' - ' + application.desired_salary}}
              </vs-td>

              <vs-td >
                <vs-chip :color="application.Status_Color" class="chip-status text-center">
                  {{ application.Status_Name | upperCase }}
                </vs-chip>
              </vs-td>

              <template class="expand-position" slot="expand">
                    <vs-col class="content-table"  vs-offset="0.3" vs-w="12" >
                       <vs-row class="mb-5 mt-1">
                          <vs-col  vs-type="flex" vs-w="2" >
                            <b style="color: #76838f; !important">{{$t('certifications')}}:</b>
                          </vs-col>
                          <vs-col  vs-type="flex" vs-w="4" >
                            <p v-if="application.certifications"><span :key="indextr" v-for="(certification, indextr) in application.certifications"> {{certification.name}}</span></p>
                          </vs-col>
                          <vs-col  vs-type="flex" vs-w="2">
                            <b style="color: #76838f; !important">{{$t('skills')}}:</b>
                          </vs-col>
                          <vs-col  vs-type="flex" vs-w="4" >
                              <p v-if="application.skills"><span :key="indextr" v-for="(skill, indextr) in application.skills"> {{skill.name}}</span></p>
                          </vs-col>
                        </vs-row>   
                        <hr style="height:1px;border:none;color:#e4eaec;background-color:#e4eaec;">
                        <vs-row class="mb-5">
                            <vs-col  vs-type="flex" vs-w="2" >
                                <b style="color: #76838f; !important">{{$t('education') | capitalize }}:</b>
                            </vs-col>
                            <vs-col  vs-type="flex" vs-w="4" >
                                <span v-if="application.Academic"> {{application.Academic}}</span>
                            </vs-col>
                            <vs-col vs-type="flex" vs-w="2" >
                                <b style="color: #76838f; !important">{{$t('state') | capitalize }}:</b>
                            </vs-col>
                            <vs-col  vs-type="flex" vs-w="4" >
                                <span v-if="application.State"> {{application.State}}</span>
                            </vs-col>
                        </vs-row>
                        <hr style="height:1px;border:none;color:#e4eaec;background-color:#e4eaec;">
                        <vs-row class="mb-5">
                            <vs-col  vs-type="flex" vs-w="2" vs-xs="2" >
                                <b style="color: #76838f; !important">Email:</b>
                            </vs-col>
                            <vs-col  vs-type="flex" vs-w="4" vs-xs="10" vs-sm="10" >
                                <span > {{application.email}}</span>
                            </vs-col>
                            <vs-col  vs-type="flex" vs-w="2" >
                                <b style="color: #76838f; !important">{{$t('documents') | capitalize }}:</b>
                            </vs-col>
                            <vs-col  vs-type="flex" vs-w="4" >
                              <vs-col class="mt-2">
                                  <vs-button
                                        color="#7367F0"
                                        type="filled"
                                        :id="'view-cv-'+application.id"
                                        @click="openFile(application.id)"
                                        icon-pack="feather"
                                        icon="icon-file-text"
                                        :disable="false"
                                      
                                  >
                                  {{ $t('view_cv') | capitalize }}
                                  </vs-button>
                                </vs-col>
                            </vs-col>
                        </vs-row>
                       
                        <hr style="height:1px;border:none;color:#e4eaec;background-color:#e4eaec;">
                        <vs-row class="mb-3">
                            <vs-col  vs-type="flex" vs-w="2">
                            <b style="color: #76838f; !important">{{$t('other_positions') | capitalize }}: </b>
                            </vs-col>
                            <vs-col  vs-type="flex" vs-w="10" >
                              <span :key="indextr" v-for="(position, indextr) in Object.entries(JSON.parse(application.lastpositions))"> {{position[1] + ', '}}{{' '}} </span>
                            </vs-col>
                        </vs-row>
                        <hr v-if="application.Rejected !== null" style="height:1px;border:none;color:#e4eaec;background-color:#e4eaec;">
                        <vs-row v-if="application.Rejected !== null">  
                            <vs-col  vs-type="flex" vs-w="2">
                            <b style="color: #76838f; !important">{{$t('reason_rejection') | capitalize }}: </b>
                            </vs-col>
                            <vs-col  vs-type="flex" vs-w="10" >
                              <span style="color:#BC1300;"> {{application.Rejected.split(/:(.+)/)[1]}} </span>
                            </vs-col>
                        </vs-row>
                        
                    </vs-col>
            
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>
    <vs-col  style="display:none;" vs-type="flex" vs-xs="12" vs-sm="3" vs-lg="3">
      <dashboard-pdf-viewer
        class="w-full"
        :files="files"
        :title="fileTitle"
      />
    </vs-col>
 
  </qb-sidebar>
</template>
<script>
import QbSidebar from '@/views/qb-components/QbSidebar'
import QbStatusCard from '@/views/qb-components/QbStatusCard'
import dashboard from '@/http/requests/dashboard'
import moment from 'moment'
import DashboardPdfViewer from '../components/pdf/DashboardPdfViewer.vue'
import { BASE_URL, URL_EXPORT_CSV, URL_CUSTOM_REPORT } from '@/urls.js'

export default {
  name: 'indirect-details',
  components: {
    QbSidebar,
    QbStatusCard,
    DashboardPdfViewer
  },
  props: {
    indirectId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      name: 'sidebar-indirect-required-details',
      loading: false,
      title:' ',
      color:' ',
      visa:false,
      sentri:false,
      data: {},
      files:[],
      fileTitle:'Resume',
      dataTable:['tests']
    }
  },
  methods: {
    open() {
      this.$forceUpdate(); 
      this.getData()
    },
    getRemainingDays(expirationDate) {
      let today = moment()
      let expiration = moment(expirationDate)
      let remainingDays = expiration.diff(today, 'days')
      
      if (remainingDays < 0) {
        return 0
      }
      return remainingDays
    },
    getData() {
      this.loading = true
      dashboard
        .indirectDetails(this.indirectId)
        .then((response) => {
          this.data = { ...response.data }
          this.title = this.data.position_title.name
          this.color = this.data.position_status.color
          if (this.data.documents.length > 0){
            this.visa = this.data.documents.find(element => element.name == "VISA");
            this.sentri = this.data.documents.find(element => element.name == "SENTRI");
          }
          this.loading = false
        })
        .catch((response) => {
          console.log(response)
           this.loading = false
        })
    },
    getFiles(id) {
      this.loading = true
      this.files = []
      dashboard
        .indirectFiles(id)
        .then((response) => {
          this.files = response.data.files
          this.files.forEach( function(valor, indice, array) {
              valor.pdf = BASE_URL + 'storage/' + valor.pdf
          });
          if(this.files.length > 0){
            let pagebutton = document.getElementById('pdf-button')
            pagebutton.click(); 
          }else{
            let pagebutton = document.getElementById('view-cv-'+id)
            pagebutton.disabled=true
          }
          this.loading = false
          
        })
        .catch((response) => {
          console.log(response)
           this.loading = false
        })
    },
    openFile(id) {
      this.getFiles(id)

    },
  },
  mounted () {
   
  }
}
</script>

<style>
table.vs-table thead th {
      font-size: 13px !important;

 }
 
 .content-table {
      font-size: 13px !important;

 }
</style>
